import moment from 'moment';
import newsCollection from '../../../shared/src/rest/newsRest';

/**
 * ====================================
 * The actions
 * ====================================
 */
const SUCCESS_GET_NEWS = 'SUCCESS_GET_NEWS';
const FAILURE_GET_NEWS = 'FAILURE_GET_NEWS';
const CHANGE_ACTIVE_NEWS = 'CHANGE_ACTIVE_NEWS';

/**
 * ====================================
 * The actions creators
 * ====================================
 */
export const successGetNews = news => ({
  type: SUCCESS_GET_NEWS,
  payload: news,
});

export const failureGetNews = () => ({
  type: FAILURE_GET_NEWS,
});

export const loadNews = () => dispatch => (
  newsCollection.getAll({ onlyPublished: true })
    .then((response) => {
      dispatch(successGetNews(response.body(false)));
    })
    .catch((err) => {
      console.error('Error while loading news', err);
      dispatch(failureGetNews());
    })
);

export const changeActiveNews = activeIndex => ({
  type: CHANGE_ACTIVE_NEWS,
  payload: activeIndex,
});

/**
 * ====================================
 * The reducer
 * ====================================
 */
const initialState = {
  data: [],
  color: '',
  duration: 0,
};

/**
 * Sorts the list of news :
 *    1 - Start date (descending),
 *    2 - title (ascending).
 *
 * @param news The list to sort.
 * @return {[*]} The sorted version of the list.
 */
const sortNews = (news) => {
  const copy = [...news];
  copy.sort((n1, n2) => {
    if (n1.startDate !== n2.startDate) {
      return n1.startDate < n2.startDate ? 1 : -1;
    }
    return n1.title < n2.title ? -1 : 1;
  });
  return copy;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_GET_NEWS: {
      const news = sortNews(action.payload);
      return {
        data: news,
        color: news.length > 0 ? news[0].color : '',
        duration: news.length > 0 ? news[0].duration : 0,
      };
    }

    /*
     * When news loading failed, a local cleanup is executed to
     * remove obsolete news.
     */
    case FAILURE_GET_NEWS: {
      const currentDate = moment();
      return {
        data: state.data
          .filter(news => !currentDate.isAfter(moment(news.endDate), 'day')),
        color: state.data.length > 0 ? state.data[0].color : '',
        duration: state.data.length > 0 ? state.data[0].duration : 0,
      };
    }
    case CHANGE_ACTIVE_NEWS:
      return {
        ...state,
        color: state.data[action.payload].color,
        duration: state.data[action.payload].duration,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/news/newsDucks.js